import React from 'react'
//import styled from '@emotion/styled'
//import { breakpoints, color } from '../../../utils/style'

const BadStars = ({ n, cssClass }) => {
  const count = +n;
  return (
    <span className={cssClass}>
      { function() {
        let stars = [];
        for (let i=0; i<count; i++) {
          stars.push(<span className="star" key={'Star' + i + n + Math.random()*i*10}>☆</span>)
        }
        return stars;
      }()}
    </span>
  )
};

export default BadStars;